<template>
  <slot v-bind="{ marksClasses }" />
</template>

<script setup lang="ts">
import type { Mark } from '@contentful/rich-text-types'
import { computed } from 'vue'

const props = defineProps<{
  marks: Mark[]
}>()

const marksClasses = computed(() => ({
  'font-bold': props.marks.some((mark) => mark.type === 'bold'),
  italic: props.marks.some((mark) => mark.type === 'italic'),
  underline: props.marks.some((mark) => mark.type === 'underline'),
  'line-through': props.marks.some((mark) => mark.type === 'strikethrough'),
  'font-mono': props.marks.some((mark) => mark.type === 'code'),
  'align-sub': props.marks.some((mark) => mark.type === 'subscript'),
  'align-super': props.marks.some((mark) => mark.type === 'superscript'),
}))

defineOptions({
  name: 'CMSTextMarks',
})
</script>
